module.exports = __webpack_public_path__ + "static/media/truck_side_1.d34f9fda.png";